// Backend configuration - Updated
// Use REACT_APP_BACKEND_URL from environment (.env or .env.production)
// Falls back to current domain if not set (for production deployment)
const envBackendUrl = process.env.REACT_APP_BACKEND_URL;
export const BACKEND_URL = envBackendUrl || window.location.origin;
export const API_URL = `${BACKEND_URL}/api`;

console.log('[Config] Backend URL:', BACKEND_URL);
